import * as React from "react";
import { CC_EMAIL_ID, COLOR, imageBaseUrl } from "../utils/variables";
import Button from "../button";
import './style.scss';
var MessageType;
(function (MessageType) {
    MessageType["SUCCESS"] = "SUCCESS";
    MessageType["ERROR"] = "ERROR";
})(MessageType || (MessageType = {}));
var FlashCard = function (props) {
    return (React.createElement("div", { className: "flashcard-container" },
        React.createElement("div", { className: "flashcard" },
            React.createElement("img", { className: "top-icon", src: props.iconUrl ? props.iconUrl : "".concat(imageBaseUrl, "/img/").concat(props.messageType === MessageType.SUCCESS ? 'success-icon.gif' : 'error-gif.gif'), alt: "status" }),
            React.createElement("h1", { className: "flashcard-heading ".concat(props.messageType === MessageType.SUCCESS ? MessageType.SUCCESS : MessageType.ERROR) }, props.heading),
            props.description &&
                React.createElement("p", { className: "error-description" }, props.description),
            props.messageType !== MessageType.SUCCESS && props.supportEmail &&
                React.createElement("p", { className: "support-message" },
                    props.supportText,
                    React.createElement("a", { href: "mailto:".concat(CC_EMAIL_ID) }, CC_EMAIL_ID)),
            !!props.onButtonClick && !!props.buttonText && React.createElement("div", { className: "flash-button-container" },
                React.createElement(Button, { buttonText: props.buttonText, onClick: props.onButtonClick, height: props.buttonHeight, width: props.buttonWidth, bgColor: props.buttonBgColor })))));
};
FlashCard.defaultProps = {
    buttonHeight: 25,
    buttonWidth: "200px",
    supportText: "Please try again or contact support",
    buttonBgColor: COLOR.PRIMARY,
};
export default FlashCard;
//# sourceMappingURL=index.js.map